import { createElement, forwardRef } from 'react';
import { grid } from '../patterns/grid.js';
import { splitProps } from '../helpers.js';
import { styled } from './factory.js';

export const Grid = /* @__PURE__ */ forwardRef(function Grid(props, ref) {
  const [patternProps, restProps] = splitProps(props, grid.propKeys)
  const styleProps = grid.raw(patternProps)
  const mergedProps = { ref, ...styleProps, ...restProps }
  return createElement(styled["div"], mergedProps)
})